export default __webpack_public_path__ + "static/5-3dea6061646126de90efdc960be5f0e9.png";